const routes = [
    {
        path: "/esl/census/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            isStaff:true
        }
    }
];

export default routes;
